import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-checkbox',
    template: ` <input id="datatable-checkbox" type="checkbox" [checked]="value" (change)="onCheckboxChange($event)" class="form-check-input" /> `,
    standalone: false,
})
export class CheckboxComponent {
    @Input()
    data: any = {};
    public value: boolean;

    @Output() emitter: Subject<{ isChecked: boolean; data: any }> = new Subject<{ isChecked: boolean; data: any }>();

    public ngOnInit() {
        this.value = this.data.isEnabled;
    }

    onCheckboxChange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.emitter.next({
            isChecked: isChecked,
            data: this.data,
        });
    }
}
